import React from 'react'

import PartySelectField from './PartySelectField'
import TimeSelectField from './TimeSelectField'
import DateSelectField from './DateSelectField'

import BkFlowMaterialLoader from '../../../elements/BkFlowMaterialLoader'
import _ from 'lodash'

const RestaurantFormSearch = props => {
	const {
		configData,
		restaurantVenueId,
		restaurantKey,
		isRestaurantClosed,
		handleClose,
		reservationDate,
		reservationDateFocused,
		handleReservationDate,
		handleReservationDateFocus,
		reservationParty,
		handleReservationParty,
		reservationTime,
		handleReservationTime,
		restaurantAvailabilityData,
		handleFetchRestaurantAvailability
	} = props

	const hotelLabels = configData.hotel.labels[0]

	return (
		<div className="bk-flow-restaurants__form-search">
			<h5>
				{ hotelLabels && hotelLabels.diningFindTable ? hotelLabels.diningFindTable : 'Find a Table' }
				<button
					className="btn btn-text-only"
					onClick={ handleClose }
				>
					<i className="material-icons">close</i>
				</button>
			</h5>

			<div className="u-form-group">
				<PartySelectField
					configData={ configData }
					restaurantKey={ restaurantKey}
					handleReservationParty={ (party) => handleReservationParty(party) }
					reservationParty={ reservationParty }
				/>

				<TimeSelectField
					configData={ configData }
					restaurantKey={ restaurantKey}
					handleReservationTime={ (time) => handleReservationTime(time) }
					reservationTime={ reservationTime }
				/>
			</div>

			<DateSelectField
				configData={ configData }
				restaurantKey={ restaurantKey}
				handleReservationDate={ (date) => handleReservationDate(date) }
				reservationDate={ reservationDate }
				reservationDateFocused={ reservationDateFocused }
				handleReservationDateFocus={ (focus) => handleReservationDateFocus(focus) }
			/>

			{ isRestaurantClosed &&
				<p className="u-font-bold u-font-small">
					{ hotelLabels &&
						hotelLabels.diningClosedMessage ? (
							hotelLabels.diningClosedMessage
						) : (
							'This venue appears to be closed on the requested date and/or time - please alter you search and try again.'
						)
					}
				</p>
			}

			{ !_.isEmpty(restaurantAvailabilityData.error)
				&& _.includes(restaurantAvailabilityData.error, restaurantVenueId) &&
				<p className="u-font-error">
					{ hotelLabels &&
						hotelLabels.diningAvailabilityErrorMessage ? (
							hotelLabels.diningAvailabilityErrorMessage
						) : (
							'Error retrieving reservation availability - please wait a moment and try again.'
						)
					}

					<span className="u-element-hidden">{ restaurantAvailabilityData.error.message }</span>
				</p>
			}

			<div className="bk-flow-restaurants__form-buttons">
				{ !_.isEmpty(restaurantAvailabilityData.loading) &&
					_.includes(restaurantAvailabilityData.loading, restaurantVenueId) ?
					<BkFlowMaterialLoader />
				:
					<button
						className="btn btn-transparent"
						onClick={() => handleFetchRestaurantAvailability(restaurantVenueId, reservationDate, reservationTime, reservationParty)}
						disabled={!reservationDate || !reservationParty || !reservationTime}
					>
						{ hotelLabels.search ? hotelLabels.search : 'Search' }
					</button>
				}
			</div>
		</div>
	)
}

export default RestaurantFormSearch



// WEBPACK FOOTER //
// ./src/components/forms/restaurantForm/elements/RestaurantFormSearch.js